import React from 'react';
import { TextInput } from '../../../../components/TextInput';
import { PdfComponent } from '../../PdfComponent';
import { usePdfTemplateContext } from '../../PdfTemplateEditorContext';

export default function PdfTemplateComponentName<T>({ component }: { component: PdfComponent }) {
  const { updateComponent } = usePdfTemplateContext<T>();

  return (
    <TextInput
      label={'Name (optional)'}
      placeholder={'Enter a display name'}
      value={component.name}
      onChange={value => updateComponent(component.id, { name: value || undefined })}
    />
  );
}
